import React, { useEffect, useContext } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import Home from './../components/home/Home';
import PrivateRoute from './PrivateRoute';
import MainMenuDrawer from './../components/shared/Drawer';
import StudentContext from './../context/student-context'
import Loading from './../components/shared/Loading'
import ErrorPage from './../components/shared/errorPage'
import Survey from './../components/survey/Survey'
import Reward from './../components/reward/Reward'
import LearningContentCategory from './../components/learningcontent/LearningContentCategory';
import LearningContents from './../components/learningcontent/trait/LearningContents';
import LearningContent from './../components/learningcontent/shared/LearningContent';
import SpecialLearningContent from './../components/learningcontent/dinosaurRecommend/SpecialLearningContent';
import Assement from './../components/learningcontent/shared/Assement';
import SurveyQuestionList from './../components/survey/questions/SurveyQuestionList'
import NonTraitLearningContents from '../components/learningcontent/nonTrait/NonTraitLearningContents';
import Profile from '../components/profile/Profile';
import Notification from '../components/notification/Notification'
import NewsRoute from '../components/news/NewsRoute'
import { Claims } from '../utils/services/cache/ClientCache'
import Challenge from './../components/challenge/Challenge'
import ChallengeDetail from './../components/challenge/detail/ChallengeDetail'
import ActivityDetail from './../components/activity/activityDetail'

const createHistory = require("history").createBrowserHistory;
export const history = createHistory();

const AppRouter = () => {
    const { loginWithRedirect, loading, logout } = useContext(StudentContext);

    useEffect(() => {
        const fn = async () => {
            if (Claims.getToken() ? false : true) {
                await loginWithRedirect();
            }
        };
        fn();
    }, []);

    if (loading || !Claims.getToken()) {
        return <Loading />;
    }

    return (
        <Router history={history}>
            <QueryParamProvider ReactRouterRoute={Route}>

                <Switch>
                    <PrivateRoute path="/" exact={true} children={<Home />} navBar = {true}/>
                    <PrivateRoute path="/SessionTimeOut" exact={true} children={<ErrorPage />  } navBar = {true} />
                    <PrivateRoute path="/Home" exact={true} children={<Home />} navBar = {true}/>
                    <PrivateRoute path="/LearningContentCategories" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/LearningContents" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/NonTraitLearningContents" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/LearningContent" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Detail/LearningContent/:id" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Assessment" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/RewardShop" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Survey" exact={true} children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/SurveyQuestionList" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Profile" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/News" children={<MainMenuDrawer />} exact={true} navBar = {true}/>
                    <PrivateRoute path="/NewsDetail" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/NewsSearch" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Notification" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Challenge" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/ChallengeDetail/:id" children={<MainMenuDrawer />} navBar = {true}/>
                    <PrivateRoute path="/Activity/:challengeId/:activityId/:memberId" children={<MainMenuDrawer />} navBar = {true}/>
                </Switch>
                <Switch>
                    <PrivateRoute path="/LearningContentCategories" children={<LearningContentCategory />} navBar = {false}/>
                    <PrivateRoute path="/LearningContents" children={<LearningContents />} navBar = {false}/>
                    <PrivateRoute path="/NonTraitLearningContents" children={<NonTraitLearningContents />} navBar = {false}/>
                    <PrivateRoute path="/LearningContent" children={<LearningContent />} navBar = {false}/>
                    <PrivateRoute path="/Detail/LearningContent/:id" children={<SpecialLearningContent />} navBar = {false}/>
                    <PrivateRoute path="/Assessment" children={<Assement />} navBar = {false}/>
                    <PrivateRoute path="/RewardShop" children={<Reward />} navBar = {false}/>
                    <PrivateRoute path="/Survey" exact={true} children={<Survey />} navBar = {false}/>
                    <PrivateRoute path="/SurveyQuestionList" children={<SurveyQuestionList />} navBar = {false}/>
                    <PrivateRoute path="/Profile" children={<Profile />} navBar = {false}/>
                    <PrivateRoute path="/News" children={<NewsRoute />} exact={true} navBar = {false}/>
                    <PrivateRoute path="/NewsDetail" children={<NewsRoute />} navBar = {false}/>
                    <PrivateRoute path="/NewsSearch" children={<NewsRoute />} navBar = {false}/>
                    <PrivateRoute path="/Notification" children={<Notification />} navBar = {false}/>
                    <PrivateRoute path="/Challenge" children={<Challenge />} navBar = {false}/>
                    <PrivateRoute path="/ChallengeDetail/:id" children={<ChallengeDetail />} navBar = {false}/>
                    <PrivateRoute path="/Activity/:challengeId/:activityId/:memberId" children={<ActivityDetail />} navBar = {false}/>
                </Switch>
            </QueryParamProvider>
        </Router>)
};

export default AppRouter;